
export const PO_ERROR_MESSAGE = `Please enter a Purchase Order Number to proceed`;
